var React = require('react');

function SquareRoot (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M576 24v48a24 24 0 0 1-24 24H357l-97.78 374.52C249.38 503 222.21 512 204.94 512c-18.64 0-35.95-8.5-48.44-28.27L67.62 320H24a24 24 0 0 1-24-24v-48a24 24 0 0 1 24-24h81.47a32 32 0 0 1 28 16.57l58.41 106.1 84.82-322.8A32 32 0 0 1 307.65 0H552a24 24 0 0 1 24 24z","className":"fa-secondary","key":1})]);
}

SquareRoot.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = SquareRoot;

SquareRoot.default = SquareRoot;
